import {Field, FieldProps} from 'formik';
import React from 'react';
import LikeInputOutlet from '../../IlikeIputOutlet';

interface TFormikInputProps extends React.HTMLProps<HTMLInputElement> {
  name: string;
  label: string;
  secondaryTitle?: React.ReactNode;
  touched?: boolean;
  onClick?: () => void;
  readonly?: boolean;
  preIcon?: string;
  labelClass?: string;
  customClass?: string;
  leftLabel?: string;
}
const FormikLikeInput = ({
  name,
  label,
  secondaryTitle,
  touched,
  readOnly,
  preIcon,
  labelClass,
  customClass,
  ...props
}: TFormikInputProps) => {
  return (
    <>
      <Field>
        {({form}: FieldProps) => {
          return (
            <>
              <LikeInputOutlet
                preIcon={preIcon}
                secondaryTitle={secondaryTitle}
                required={props.required}
                label={label}
                name={name}
                type={props?.type}
                rows={props?.rows}
                value={form.values[name]}
                onBlur={() => form.setFieldTouched(name, true)}
                errors={form.errors[name]?.toString()}
                touched={touched || Boolean(form.touched[name])}
                placeholder={props.placeholder}
                readOnly={readOnly}
                customClass={customClass}
                labelClass={labelClass}
                {...props}
              />
            </>
          );
        }}
      </Field>
    </>
  );
};

export default FormikLikeInput;
